/* eslint-disable simple-import-sort/imports */
import { keyframes, styled } from '@mui/material/styles'
import React from 'react'

import { COLORS } from '../../theme/colors'
import { MsdkComponent } from '../../utils'
import { ButtonAlignProps } from './ButtonAlignProps'
import { ButtonBase } from './ButtonBase'
import { createComponentWrapperWithRef } from '../../theme'
/* eslint-enable simple-import-sort/imports */

const breatheAnimation = keyframes`
 0% {  opacity: 1 }
 50% {  opacity: 0.3; }
 100% {  opacity: 1; }
`

const StyledMuiButtonScheleton = styled(ButtonBase, { shouldForwardProp: (prop) => prop !== '$alignLeft' })<{
  $alignLeft?: boolean
}>`
  background-color: ${COLORS.action.diasbeldBackround};
  border-radius: 20px;
  box-shadow: unset;
  padding: 8px 24px;
  height: 40px;
  font-size: 0.938rem;
  font-weight: 700;
  line-height: 160%;
  text-transform: unset;
  ${({ $alignLeft }) => ($alignLeft ? 'margin-right: auto;' : '')}

  width: 180px;

  animation-name: ${breatheAnimation};
  animation-duration: 4s;
  animation-iteration-count: infinite;
`

const StyledNovaButtonScheleton = styled(ButtonBase, { shouldForwardProp: (prop) => prop !== '$alignLeft' })<{
  $alignLeft?: boolean
}>`
  background-color: ${COLORS.action.diasbeldBackround};
  ${({ $alignLeft }) => ($alignLeft ? 'margin-right: auto;' : '')}

  width: 180px;

  animation-name: ${breatheAnimation};
  animation-duration: 4s;
  animation-iteration-count: infinite;
`

const StyledButtonScheleton = createComponentWrapperWithRef(
  {
    mui: StyledMuiButtonScheleton,
    nova: StyledNovaButtonScheleton,
  },
  'StyledButtonScheleton',
)

export function ButtonScheleton({ ...props }: ButtonAlignProps): MsdkComponent {
  return (
    <StyledButtonScheleton disabled $alignLeft={props.alignLeft} variant="contained" {...props}>
      {props.children}
    </StyledButtonScheleton>
  )
}
